import { Controller, useFormContext } from "react-hook-form";
import { IMaskInput } from "react-imask";
import { twMerge } from "tailwind-merge";

import { TextField } from "ui/text-field";
import { TextArea } from "ui/text-area";
import { FieldErrorMessage, FieldLabel } from "ui/forms";

// Mask for mm/dd/yyyy
export const dateFormat = [/[0-9]/, /\d/, "/", /[0-9]/, /\d/, "/", /[0-9]/, /\d/, /\d/, /\d/];

const BatchCreationForm = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Controller
        name="name"
        control={control}
        render={({ field }) => (
          <TextField
            label="Batch name"
            required
            errMessage={errors?.name?.message as string}
            {...field}
          />
        )}
      />
      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <TextArea
            label="Batch description"
            placeholder=""
            required
            errMessage={errors?.description?.message as string}
            {...field}
          />
        )}
      />
      <Controller
        name="dueDate"
        control={control}
        defaultValue=""
        render={({ field: { value, onChange, onBlur, ref } }) => (
          <div className="flex w-full flex-col gap-1.5">
            <FieldLabel name="dueDate" required>
              Approval due date
            </FieldLabel>
            <IMaskInput
              mask="00/00/0000"
              value={value}
              onAccept={onChange}
              onBlur={onBlur}
              ref={ref}
              placeholder="mm/dd/yyyy"
              className={twMerge(
                "flex h-10 w-full rounded-md border border-neutrals-200 px-3 py-1.5 text-base font-normal text-neutrals-900 outline-none placeholder-neutrals-600",
                !errors.dueDate?.message
                  ? "focus:border-aqua-500 focus:shadow-input"
                  : "border-critical-700 focus:shadow-input-invalid",
              )}
            />
            {!!errors.dueDate?.message && (
              <FieldErrorMessage name="dueDate" message={errors.dueDate.message as string} />
            )}
          </div>
        )}
      />

      <Controller
        name="mondayBoardLink"
        control={control}
        render={({ field }) => (
          <TextField
            label="Monday board link"
            {...field}
            helperText="Please include full address starting with https://."
          />
        )}
      />
    </>
  );
};

export default BatchCreationForm;
